import { Link } from "react-router-dom";
import type { Episode } from "@/types";

export default function RelatedEpisodes({ episodes }: { episodes: Episode[] }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      {episodes.map((episode) => (
        <Link
          key={episode.id}
          to={`/detail/${episode.id}`}
          className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
        >
          <div className="aspect-video w-full overflow-hidden bg-background-200">
            <img
              src={episode.cover}
              alt={`出轨同学会第${episode.number}集《${episode.title}》剧照`}
              title={`出轨同学会 第${episode.number}集 ${episode.title}`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="p-4">
            <p className="font-heading text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-700">
              第 {episode.number} 集 · {episode.title}
            </p>
            <p className="mt-1.5 line-clamp-2 font-label text-xs leading-relaxed text-foreground-500">
              {episode.summary}
            </p>
          </div>
        </Link>
      ))}
    </div>
  );
}